






















import Vue from 'vue'
import NavBar from '@/components/NavBar.vue'
import NavBarMobile from '@/components/NavBarMobile.vue'
import TestnetAlert from '@/components/misc/TestnetAlert.vue'
// import ResponsiveGuidelines from '@/components/misc/ResponsiveGuidelines.vue'
import Footer from '@/components/Footer.vue'
import { IMetaTag } from '@/router/IMetaTag'
import Notifications from '@/components/Notifications.vue'

export default Vue.extend({
    name: 'App',
    components: {
        NavBar,
        NavBarMobile,
        // ResponsiveGuidelines,
        TestnetAlert,
        Footer,
        Notifications,
    },
    data: () => ({}),
    watch: {
        $route: {
            handler: (to) => {
                // Remove stale tags from the document using key attribute
                Array.from(document.querySelectorAll('[vue-router-data]')).map(
                    (el) => {
                        if (el.parentNode) {
                            el.parentNode.removeChild(el)
                            return
                        }
                    }
                )
                // Update tags
                document.title = to.meta.title || 'Avalanche Explorer'
                if (to.meta.metaTags) {
                    to.meta.metaTags
                        .map((tagDef: IMetaTag) => {
                            const tag = document.createElement('meta')
                            Object.keys(tagDef).forEach((key) =>
                                tag.setAttribute(key, tagDef[key])
                            )
                            tag.setAttribute('vue-router-data', '')
                            return tag
                        })
                        .forEach((tag: HTMLMetaElement) =>
                            document.head.appendChild(tag)
                        )
                }
            },
            immediate: true,
        },
    },
    async created() {
        this.$store.dispatch('init')
        this.$store.dispatch('Platform/init')
        await this.$store.dispatch('Network/init')
    },
})
